<template>
  <div class="mysearch">
    <input type="text" :value="info" class="searchbox" placeholder="搜索">
  </div>
</template>
<script>
export default {
  name: 'Search',
  data () {
    return {
      info: this.value || ""
    }
  },
  props: {
    fn: {
      type: Function,
      default: () => { }
    },
    value: {
      type: String,
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.info = newVal
      }
    }
  },
  methods: {
    handleSearch: function () {
      //执行props传入函数
      this.fn(this.value)

    }
  }
}
</script>
<style scoped>
.mysearch {
    border-radius: 15px;
    overflow: hidden;
}
.searchbox {
    background-color: #f6f6f6;
    width: 100%;
    padding: 1.3333vw 2.6667vw 1.3333vw 12.8vw;
    border-radius: 4vw;
    height: 8vw;
    box-sizing: border-box;
}
.mysearch {
    position: relative;
}
.mysearch:before {
    content: "";
    width: 7.4667vw;
    height: 5.3333vw;
    /* border-right: 1px solid #999999; */
    background: url("../assets/img/icon-search.png") no-repeat;
    background-size: 5.3333vw 5.3333vw;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 4vw;
}
</style>